<template>
<div class="chapter">
<div class="inner_page">
<div id="eBook4242-2.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="Title para-style-override-2" id="toc_marker-3"><span class="char-style-override-3">Other Titles by Jimmy Santiago Baca</span></p>
<p class="poems">Published by Grove Press</p>
<p class="poems">
</p><p class="poems"><span class="char-style-override-4">Memoir</span></p>
<p class="poems"><span class="char-style-override-5">A Place to Stand</span></p>
<p class="poems">
</p><p class="poems"><span class="char-style-override-4">Fiction</span></p>
<p class="poems"><span class="char-style-override-5">The Importance of a Piece of Paper</span></p>
<p class="poems"><span class="char-style-override-5">A Glass of Water</span></p>
<p class="poems">
</p><p class="poems"><span class="char-style-override-4">Poetry</span></p>
<p class="poems"><span class="char-style-override-5">Healing Earthquakes</span></p>
<p class="poems"><span class="char-style-override-5">C-Train and Thirteen Mexicans</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eBook42422.vue?3707eadd